import { Injectable } from '@angular/core';

const STORAGE_KEY = 'auth_return_url';
const ALLOWED_TOP_LEVEL_ROUTES = new Set(['', 'login', 'sign-up', 'teams', 'embedded']);

export function normalizeAppReturnUrl(url: string): string | null {
  try {
    const parsed = new URL(url, globalThis.location.origin);
    if (parsed.origin !== globalThis.location.origin) return null;

    const normalized = parsed.pathname + parsed.search + parsed.hash;
    if (!normalized.startsWith('/')) return null;

    const topLevelSegment =
      normalized.split('?')[0].split('#')[0].split('/').filter(Boolean)[0] ?? '';
    return ALLOWED_TOP_LEVEL_ROUTES.has(topLevelSegment) ? normalized : '/';
  } catch {
    if (!url.startsWith('/')) return null;
    const topLevelSegment = url.split('?')[0].split('#')[0].split('/').filter(Boolean)[0] ?? '';
    return ALLOWED_TOP_LEVEL_ROUTES.has(topLevelSegment) ? url : '/';
  }
}

@Injectable({ providedIn: 'root' })
export class AuthRedirectService {
  save(url: string): void {
    const normalized = normalizeAppReturnUrl(url);
    if (!normalized) return;
    sessionStorage.setItem(STORAGE_KEY, normalized);
  }

  consume(): string | null {
    const url = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return url ? normalizeAppReturnUrl(url) : null;
  }
}
